import BaseInventoryName from './BaseInventoryName';

export default BaseInventoryName;
export { BaseInventoryName };
